

import React, { createContext, useContext, useEffect, useReducer } from 'react'
import reducer from './reducer';

const initialState = {
    contextLoading: true, // Se pone en falso cuando el conexto se ha actualizado con las variables minimamente requeridas 
    currentUser: null,    // Mantiene los datos del usuario logeado
    openLogin: false,     // Variable para abrir desde distintos lugares el dialogo de LogIn
    passwordModal: { open: false }, // Para la ventana modal de cambio de contraseña
    profile: { open: false, file: null, photoUrl: '' },   // Variable/Objeto para gestionar el dialogo de Profile
    okCancelDialog: { open: false, title: '', message: '', repuesta: '', callerData: null }, //Dialogo para confirmar una acción
    loading: false,       // Para mostar o no el gráfico de "Loading"
    alert: { open: false, severity: 'info', message: '' },
    drawerState: false,   //mantiene el estado del drawer, abierto o cerrado

    zonas: [],
    datAlarma: { id: 0, deviceId: 0x00010001, macAdd: '6055F9759730', imei: '', userId: 0, celAlarma: 0, estado: 0, monitoreo: 0 },
    resultConfig: { configId: 0, resp: 1 }, // Por defecto la respuesta en 1, porque 0 significa ok

    marcas: [],           // Array para guardar todas las marcas recibidas desde la base de datos
    users: [],            // Usuarios
    productos: [],        // Productos
    categorias: [],       // Categoria de productos
    proveedores: [],      // Array que guarda todos los proveedores
}

const Context = createContext(initialState);

export const useValue = () => {
    return useContext(Context);
}


const ContextProvider = ({ children }) => {

    const [state, dispatch] = useReducer(reducer, initialState);

    const { contextLoading } = state;

    /*  En el primer renderizado se busca si se tiene algún usuario ya logueado, para no solicitar nuevamente se loguee
        cada vez que entra a la página */
    useEffect(() => {
        try {
            const storedUser = localStorage.getItem('currentUser');

            // Verificamos que exista y que NO sea la palabra "undefined"
            if (storedUser && storedUser !== 'undefined') {
                const currentUserSaved = JSON.parse(storedUser);
                dispatch({ type: 'UPDATE_USER', payload: currentUserSaved });
            }
        } catch (error) {
            // Si hay algún error leyendo el JSON (ej. datos corruptos), lo atrapamos aquí para que la app no se rompa
            //console.error("Error leyendo el currentUser del localStorage:", error);
            localStorage.removeItem('currentUser'); // Limpiamos el dato corrupto
        } finally {
            // El finally asegura que esto se ejecute SIEMPRE, haya habido error o no
            dispatch({ type: 'CLEAR_CONTEXT_LOADING' });
        }
    }, []);

    return (
        <Context.Provider value={{ state, dispatch }}>
            {children}
        </Context.Provider>
    )
}

export default ContextProvider